import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../common_report_offcanvas/Common_Report_Offcanvas";
import E_P_P_S_F from "./e_p_p_s_f/E_P_P_S_F";
import E_P_P_S_T from "./e_p_p_s_t/E_P_P_S_T";


const E_P_P_S = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <E_P_P_S_F setShow={setShow} />
      </div>

      <div className="report_table_div">
        <E_P_P_S_T />
      </div>

      <Common_Report_Offcanvas
        title={"Externally Provided Product Services Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default E_P_P_S;
